import {AnyEvent, CURRENT_USER_SIGNED_OUT_EVENT} from '../type';

export default function currentUserSignedOut(): AnyEvent {
  return {
    type: CURRENT_USER_SIGNED_OUT_EVENT
  }
}
